import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import axios from 'axios';
import Api from './Config';

i18n
  .use(reactI18nextModule)
  .use(Backend)
  .init({
    fallbackLng: 'en',

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',
    debug: (() => process.env.NODE_ENV === 'development')(),
    saveMissing: true,
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('Fallback:', lng, ns, key, fallbackValue);
      }
    },
    backend: {
      loadPath: `${Api.base}{{lng}}/{{ns}}`,
      parse: data => data,
      ajax: (url, options, callback) => {
        axios.get(url, {
          withCredentials: true,
          crossDomain: true,
        }).then((response) => {
          callback(response.data, { status: 200 });
        }).catch((error) => {
          callback(null, { status: error.response.status.toString() });
        });
      },

    },
    react: {
      wait: true,
    },
  });


export default i18n;



// WEBPACK FOOTER //
// ./frontend/js/Base/i18n.jsx